import React, { useEffect, useRef } from 'react';
import { CarouselComponent } from 'gallery-ar-component';
import './Carousel.css';
import { tabsData } from '../data/data';

const Carousel = () => {
  const toolTipRef = useRef<any>(null);

  useEffect(() => {
    if (toolTipRef.current) {
      window.onmousemove = function (e: any) {
        let x = e.clientX,
          y = e.clientY;
        toolTipRef.current.style.top = y + 20 + 'px';
        toolTipRef.current.style.left = x + 20 + 'px';
      };
    }
  }, [toolTipRef]);

  return (
    <div className='collection'>
      <div className='collection-wrapper'>
        <span className='span' ref={toolTipRef}>
          <div>tabsData: tabsData</div>
          <div>width: 40</div>
          <div>height: 40</div>
          <div>navigation: true</div>
          <div>navigationPosition: 'right'</div>
          <div> borderRadius: 1</div>
          <div>dotSize: 6</div>
          <div>dotColorActive: '#eee'</div>
          <div>dotColorHover: '#eee'</div>
          <div> dotBorderColor: '#eee'</div>
          <div>dotMargin: '0.5 1'</div>
          <div>dotMarginMobile: '3 2'</div>
          <div>dotBorder: 1</div>
        </span>
        <div className='type-carousel'>
          <CarouselComponent
            tabsData={tabsData}
            width={40}
            height={40}
            navigation={true}
            navigationPosition={'right'}
            borderRadius={1}
            dotSize={6}
            dotColorActive={'#eee'}
            dotColorHover={'#eee'}
            dotBorderColor={'#eee'}
            dotMargin={'0.5 1'}
            dotMarginMobile={'3 2'}
            dotBorder={1}
          />
        </div>
      </div>
    </div>
  );
};

export default Carousel;
